import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import Layout from '../../components/layout/Layout';

const PrivacyPolicy: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleBackClick = () => {
    if (location.state?.returnTo) {
      navigate(location.state.returnTo, { 
        state: { formData: location.state.formData }
      });
    } else {
      navigate(-1);
    }
  };

  return (
    <Layout>
      <MainContainer>
        <SloganSection>
          <SloganTitle>대한민국의학한림원 × 투비닥터 의료 AI 캠퍼스 개인정보처리방침</SloganTitle>
        </SloganSection>
        
        <ContentContainer>
          <TermsContent>
            <Section>
              <SectionContent>
                투비닥터는 이용자의 개인정보를 중요시하며, "개인정보 보호법", "정보통신망 이용촉진 및 정보보호 등에 관한 법률" 등 관련 법령을 준수하고 있습니다. 투비닥터는 개인정보처리방침을 통하여 이용자의 개인정보가 어떻게 수집·이용·보관·파기되는지 안내합니다.
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>제1조 (수집하는 개인정보 항목)</SectionTitle>
              <SectionContent>
                1. 회원 가입 시
                {'\n'}   가. 공통 항목: 이름, 이메일, 비밀번호, 휴대전화번호, 생년월일
                {'\n'}   나. 의대생 회원: 재학 중인 학교명, 학생증 사본 또는 재학증명서 사본
                {'\n'}   다. 의사 회원: 진료과목, 의사면허번호
                {'\n'}2. 유료 서비스 이용 시: 결제정보(신용카드 번호, 계좌정보 등은 PG사를 통해 수집하며 회사는 직접 저장하지 않음)
                {'\n'}3. 상담 및 문의 시: 이메일, 문의내용 등
                {'\n'}4. 서비스 이용 시 자동 수집: IP 주소, 쿠키, 접속기기 정보, 서비스 이용기록, 방문 기록 등
                {'\n'}5. 투비닥터는 만14세 미만 아동의 개인정보를 수집하는 경우, 법정대리인의 동의를 얻기 위해 필요한 최소한의 정보(법정대리인의 이름, 연락처 등)를 수집할 수 있으며, 동의 절차 및 아동의 권리 보호에 관한 사항을 별도로 안내합니다.
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>제2조 (개인정보 수집 및 이용목적)</SectionTitle>
              <SectionContent>
                투비닥터는 다음의 목적을 위해 개인정보를 수집 및 이용합니다.
                {'\n\n'}1. 회원 관리: 본인 확인, 서비스 이용에 따른 본인 식별, 가입 의사 확인, 부정 이용 방지 등
                {'\n'}2. 서비스 제공: 강의 콘텐츠 제공, 예약 처리, 결제, 맞춤형 서비스 제공 등
                {'\n'}3. 고객지원 및 민원 처리
                {'\n'}4. 마케팅 및 광고: 이벤트 안내, 설문조사, 신규 서비스 소개 등 (사전 동의 시)
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>제3조 (개인정보의 보유 및 이용기간)</SectionTitle>
              <SectionContent>
                1. 회원 탈퇴 시까지 보유하며, 탈퇴 요청 또는 수집·이용 목적 달성 시 지체 없이 파기합니다.
                {'\n'}2. 단, 관계 법령에 따라 일정 기간 보관해야 하는 정보는 해당 기간 동안 보유합니다.
                {'\n'}3. 투비닥터는 1년동안 서비스를 이용하지 않은 회원의 개인정보는 '휴면계정'으로 전환하고, 다른 회원의 개인정보와 분리하여 별도로 저장, 관리합니다. 투비닥터는 휴면계정전환 30일전까지 해당사실을 이메일 등을 통해 회원에게 사전 통지 합니다.
                {'\n\n'}* 전자상거래 등 소비자 보호에 관한 법률: 계약 또는 청약철회 기록 5년, 대금결제 및 재화 등의 공급기록 5년
                {'\n'}* 통신비밀보호법: 접속기록 3개월
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>제4조 (개인정보의 제3자 제공)</SectionTitle>
              <SectionContent>
                투비닥터는 원칙적으로 회원의 개인정보를 외부에 제공하지 않습니다. 다만 다음의 경우 예외로 합니다.
                {'\n\n'}1. 회원이 사전에 동의한 경우
                {'\n'}2. 법령에 의거하거나 수사기관의 요청에 의한 경우
                {'\n'}3. 투비닥터는 다음의 경우 회원의 동의를 얻어 개인정보를 제3자에게 제공할 수 있습니다.
                {'\n'}   - 제공받는자: 대한민국의학한림원, 정보통신산업진흥원
                {'\n'}   - 제공목적: 정부 지원 사업 결과 보고 및 성과 분석
                {'\n'}   - 제공항목: 성별, 연령대, 소속 정보 등 비식별화된 통계 정보
                {'\n'}   - 보유 및 이용기간: 사업종료 후 즉시 파기
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>제5조 (개인정보의 위탁 처리)</SectionTitle>
              <SectionContent>
                투비닥터는 서비스 제공을 위하여 필요한 업무 중 일부를 외부 업체에 위탁하고 있으며, 위탁 시 개인정보가 안전하게 처리되도록 관리·감독합니다.
                {'\n\n'}* 휴대폰 본인확인: (주)드림시큐리티
                {'\n'}* 서버 운영 및 호스팅: Microsoft Azure
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>제6조 (개인정보의 파기절차 및 방법)</SectionTitle>
              <SectionContent>
                개인정보는 수집·이용 목적이 달성된 후 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후 파기됩니다.
                {'\n\n'}* 전자적 파일: 복구 불가능한 방법으로 영구 삭제
                {'\n'}* 출력물: 분쇄하거나 소각 처리
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>제7조 (이용자의 권리와 행사방법)</SectionTitle>
              <SectionContent>
                1. 이용자는 언제든지 자신의 개인정보를 조회하거나 수정할 수 있으며, 회원 탈퇴를 통해 처리정지를 요구할 수 있습니다.
                {'\n'}2. 개인정보 열람 및 정정, 동의 철회는 서비스 내 설정 또는 고객센터를 통해 요청할 수 있습니다.
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>제8조 (개인정보 자동 수집 장치의 설치/운영 및 거부)</SectionTitle>
              <SectionContent>
                1. 회사는 쿠키(Cookie)를 통해 이용자의 서비스 이용패턴을 분석하며 맞춤형 서비스를 제공합니다.
                {'\n'}2. 이용자는 웹브라우저 설정을 통해 쿠키 저장을 거부할 수 있으나, 이 경우 일부 서비스 이용에 제한이 있을 수 있습니다.
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>제9조 (개인정보 보호를 위한 기술적/관리적 대책)</SectionTitle>
              <SectionContent>
                1. 회사는 개인정보의 안전성을 확보하기 위해 다음과 같은 조치를 취하고 있습니다.
                {'\n\n'}* 개인정보 암호화, 접근제어 시스템 구축, 보안프로그램 설치
                {'\n'}* 개인정보 처리자 최소화 및 교육 실시
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>제10조 (개인정보 보호책임자)</SectionTitle>
              <SectionContent>
                * 책임자: 김태훈 (부대표)
                {'\n'}* 이메일: tobedoc2020@gmail.com
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>제11조 (개정 전 고지의무)</SectionTitle>
              <SectionContent>
                현 개인정보처리방침의 내용 추가, 삭제 및 수정이 있을 경우 개정 최소 7일 전부터 웹사이트를 통해 공지합니다.
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>제12조 (영업양수등의통지)</SectionTitle>
              <SectionContent>
                투비닥터는 영업의 전부 또는 일부를 양도하거나 합병, 상속 등으로 그 권리, 의무를 이전하는 경우 이용자에게 관련 내용으로 다음의 항목을 통지합니다.
                {'\n\n'}1. 영업의 전부 또는 일부의 양도, 합병 또는 상속의 사실
                {'\n'}2. 권리, 의무를 승계한 자의 성명, 주소, 연락처
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>제13조 (링크사이트)</SectionTitle>
              <SectionContent>
                회사는 이용자에게 다른 회사의 웹사이트에 대한 링크를 제공할 수 있습니다. 이 경우 링크되어 있는 웹사이트가 개인정보를 수집하는 행위에 대해서는 본 개인정보처리방침이 적용되지 않습니다.
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>제14조 (정보주체의 권익침해에 대한 구제방법)</SectionTitle>
              <SectionContent>
                정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보침해의 신고, 상담에 대하여는 아래의 기관에 문의하시기 바랍니다.
                {'\n\n'}- 개인정보분쟁조정위원회 : (국번없이) 1833-6972 (www.kopico.go.kr)
                {'\n'}- 개인정보침해신고센터 : (국번없이) 118 (privacy.kisa.or.kr)
                {'\n'}- 대검찰청 : (국번없이) 1301 (www.spo.go.kr)
                {'\n'}- 경찰청 : (국번없이) 182 (ecrm.cyber.go.kr)
                {'\n\n'}「개인정보보호법」제35조(개인정보의 열람), 제36조(개인정보의 정정·삭제), 제37조(개인정보의 처리정지 등)의 규정에 의한 요구에 대하여 공공기관의 장이 행한 처분 또는 부작위로 인하여 권리 또는 이익의 침해를 받은 자는 행정심판법이 정하는 바에 따라 행정심판을 청구할 수 있습니다.
                {'\n\n'}※ 행정심판에 대해 자세한 사항은 중앙행정심판위원회(www.simpan.go.kr) 홈페이지를 참고하시기 바랍니다.
              </SectionContent>
            </Section>

            <Section>
              <SectionTitle>부칙</SectionTitle>
              <SectionContent>
                본 방침은 2025년 10월 1일부터 시행합니다.
              </SectionContent>
            </Section>
          </TermsContent>
        </ContentContainer>
      </MainContainer>
    </Layout>
  );
};

const MainContainer = styled.main`
  max-width: ${({ theme }) => theme.layout.containerWidth};
  margin: 0 auto;
  padding: 64px 80px;
  min-height: 100vh;
  
  @media (max-width: 1024px) {
    padding: 64px 40px;
  }
  
  @media (max-width: 768px) {
    padding: 64px 20px;
  }
`;

const SloganSection = styled.div`
  margin-bottom: 48px;
`;

const SloganTitle = styled.h1`
  font-family: 'Pretendard JP', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 32px;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: -1.13px;
  color: #171719;
  margin: 0;
  text-align: left;
`;

const ContentContainer = styled.div`
  width: 100%;
`;

const TermsContent = styled.div`
  background: transparent;
`;

const Section = styled.div`
  margin-bottom: 32px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const SectionTitle = styled.h2`
  font-family: 'Pretendard JP', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.4;
  color: #171719;
  margin: 0 0 12px 0;
`;

const SectionContent = styled.p`
  font-family: 'Pretendard JP', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.6;
  color: rgba(23, 23, 25, 0.88);
  margin: 0;
  white-space: pre-line;
`;

export default PrivacyPolicy;